var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"investigation-tab-form"},[_c('gc-form',{attrs:{"formOptions":_vm.formOptions,"formItems":_vm.formItems,"isNormal":true,"data-model":_vm.investigation,"formMode":_vm.isReadOnly ? 'review' : 'edit',"scrollingEnabled":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }